import React, { useState } from "react";
import Messages from "../../../../../../../../../../../../components/Messages";
import RangeSlider from "../../../../../../../../../../../../components/RangeSlider";
import styles from './CustomAppRequirements.module.scss'

export default function CustomAppRequirements({
                                                  app, messages, update
                                              }) {


    const [cpu, setCpu] = useState(!!app.cpu && !isNaN(parseFloat(app.cpu)) ? parseFloat(app.cpu).toFixed(1) : '0');
    const [disk_size, setStorage] = useState(app.disk_size || '0Gb');
    const [ram_size, setRam] = useState(app.ram_size || '0Gb');

    const onRangeChange = (data, unit) => {
        const {name, value} = data;
        let handledValue = unit ? value + unit : value;

        if (name === 'cpu') {
            handledValue = !!handledValue && !isNaN(parseFloat(handledValue)) ? parseFloat(handledValue).toFixed(1) : '0';
        }

        update({[name] : handledValue});

        if (name === 'cpu') setCpu(handledValue);
        if (name === 'disk_size') setStorage(handledValue);
        if (name === 'ram_size') setRam(handledValue);
    };

    // const errStorage = errors ? errors.filter(e => e.target === 'hardware-storage' && e.type === 'error') : [];
    // const warnStorage = errors ? errors.filter(e => e.target === 'hardware-storage' && e.type === 'warning') : [];
    // const errRAM = errors ? errors.filter(e => e.target === 'hardware-ram' && e.type === 'error') : [];
    // const warnRAM = errors ? errors.filter(e => e.target === 'hardware-ram' && e.type === 'warning') : [];

    let storageValues = [];

    for (let i = 0; i <= 1; i = parseFloat((i + 0.1).toPrecision(12))) storageValues.push(i);
    for (let i = 1.2; i <= 5; i = parseFloat((i + 0.2).toPrecision(12))) storageValues.push(i);
    for (let i = 5.5; i <= 10; i = parseFloat((i + 0.5).toPrecision(12))) storageValues.push(i);
    for (let i = 11; i <= 20; i += 1) storageValues.push(i);
    for (let i = 25; i <= 50; i += 5) storageValues.push(i);
    for (let i = 60; i <= 150; i += 10) storageValues.push(i);

    let ramValues = [];

    for (let i = 0; i <= 2; i = parseFloat((i + 0.1).toPrecision(12))) ramValues.push(i);
    for (let i = 2.2; i <= 4; i = parseFloat((i + 0.2).toPrecision(12))) ramValues.push(i);
    for (let i = 4.5; i <= 8; i = parseFloat((i + 0.5).toPrecision(12))) ramValues.push(i);
    for (let i = 9; i <= 32; i += 1) ramValues.push(i);

    let cpuValues = [];

    for (let i = 0; i <= 2; i = parseFloat((i + 0.1).toPrecision(12))) cpuValues.push(i);
    for (let i = 2.2; i <= 4; i = parseFloat((i + 0.2).toPrecision(12))) cpuValues.push(i);
    for (let i = 4.5; i <= 8; i = parseFloat((i + 0.5).toPrecision(12))) cpuValues.push(i);
    // for (let i = 9; i <= 32; i += 1) cpuValues.push(i);


    return (
        <div className={styles['hardware']}>
            {/*<p className={styles['hardware__title']}>Set your application requirements</p>*/}
            <div className={styles['hardware__req']}>
                <div className={styles['hardware__req__item']}>
                    <p className={styles['hardware__req__item__title']}>Storage</p>
                    {/*<ErrorMessage errors={errStorage} warnings={warnStorage}/>*/}
                    <Messages messages={messages} target={`custom-${app._id}-storage`}/>
                    <RangeSlider
                        className={styles['hardware__req__item__slider']}
                        name='disk_size'
                        onChange={data => onRangeChange(data, 'Gb')}
                        value={!isNaN(parseFloat(disk_size)) ? parseFloat(disk_size) : 0}
                        // min={0}
                        // max={50}
                        step={0.5}
                        values={storageValues}
                        unit='Gb'
                    />
                </div>
                <div className={styles['hardware__req__item']}>
                    <p className={styles['hardware__req__item__title']}>RAM</p>
                    {/*<ErrorMessage errors={errRAM} warnings={warnRAM}/>*/}
                    <Messages messages={messages} target={`custom-${app._id}-ram`}/>
                    <RangeSlider
                        className={styles['hardware__req__item__slider']}
                        name='ram_size'
                        onChange={data => onRangeChange(data, 'Gb')}
                        value={!isNaN(parseFloat(ram_size)) ? parseFloat(ram_size) : 0}
                        // min={0}
                        // max={5}
                        step={0.5}
                        values={ramValues}
                        unit='Gb'
                    />
                </div>
                <div className={styles['hardware__req__item']}>
                    <p className={styles['hardware__req__item__title']}>CPU</p>
                    {/*<ErrorMessage errors={errRAM} warnings={warnRAM}/>*/}
                    <Messages messages={messages} target={`custom-${app._id}-cpu`}/>
                    <RangeSlider
                        className={styles['hardware__req__item__slider']}
                        name='cpu'
                        onChange={data => onRangeChange(data)}
                        value={!isNaN(parseFloat(cpu)) ? parseFloat(cpu) : 0}
                        // min={0}
                        // max={5}
                        step={0.5}
                        values={cpuValues}
                        // unit='Gb'
                    />
                </div>
            </div>
        </div>
    )
}